import { createSlice } from '@reduxjs/toolkit';
import { createReducerNames } from '../../../../core/helpers/default';

const name = 'organizationReviewChecklist';

const reducersKeys = {
  getDataRequest: 'getDataRequest',
  getDataSuccess: 'getDataSuccess',
  getDataFailure: 'getDataFailure',
};

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const slice = createSlice({
  name,
  initialState,
  reducers: {
    [reducersKeys.getDataRequest]: (state) => {
      state.loading = true;
      state.data = [];
    },
    [reducersKeys.getDataSuccess]: (state, { payload }) => {
      state.data = payload.data;
      state.loading = false;
    },
    [reducersKeys.getDataFailure]: (state, { payload }) => {
      state.loading = false;
      state.error = payload.error;
    },
  },
});

export const organizationReviewChecklistReducer = createReducerNames(name, reducersKeys);
export const { actions } = slice;

export default slice.reducer;
